// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavClanProfile_nav_3rkSq","link":"NavClanProfile_link_3jvhj","linkCurrent":"NavClanProfile_linkCurrent_1Xr_e","title":"NavClanProfile_title_3MKXI"};